<template>
  <roe-error-message :field="design.profit_sharing_excludes_commissions_comp_yesno">
    <roe-radio-input
      v-model="design.$model.profit_sharing_excludes_commissions_comp_yesno"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
export default {
  name: "RoeEmployerOtherComissionsRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
